import { call, fork, put, takeEvery } from "typed-redux-saga";
import { getAppServerClient } from "@advosys/component-app-server-client-js";
import { actions as dynamicInvoicePageActions } from "../../dynamic-invoice-page-store";
import { actions, DynamicInvoiceDialogActionTypes } from "./dynamic-invoice-dialog-store";
function* savePreparedInvoice(preparedInvoiceId, preparedInvoice) {
    const apiResult = yield* call(getAppServerClient().finance.preparedInvoiceV2.updatePreparedInvoiceAsync, preparedInvoiceId, preparedInvoice);
    if (apiResult.ok) {
        const updatedResult = yield* call(getAppServerClient().finance.preparedInvoiceV2.getPreparedInvoiceAsync, preparedInvoiceId);
        return updatedResult.ok ? updatedResult.data : updatedResult.error;
    }
    return apiResult.error;
}
function* saveAndApprovePreparedInvoiceHandler(action) {
    const preparedInvoice = yield* call(savePreparedInvoice, action.payload.preparedInvoiceId, action.payload.preparedInvoice);
    if (typeof preparedInvoice === "string") {
        yield* put(actions.saveAndApprovePreparedInvoiceFail(preparedInvoice));
        return;
    }
    const apiResult = yield* call(getAppServerClient().finance.preparedInvoiceV2.approvePreparedInvoiceAsync, action.payload.preparedInvoiceId);
    if (apiResult.ok) {
        yield* put(actions.saveAndApprovePreparedInvoiceSuccess(action.payload.preparedInvoiceId));
        yield* put(dynamicInvoicePageActions.hideDynamicInvoiceDialog());
        return;
    }
    yield* put(actions.saveAndApprovePreparedInvoiceFail(apiResult.error));
}
function* watchSaveAndApprovePreparedInvoiceRequest() {
    yield* takeEvery(DynamicInvoiceDialogActionTypes.SaveAndApprovePreparedInvoiceRequest, saveAndApprovePreparedInvoiceHandler);
}
function* savePreparedInvoiceHandler(action) {
    const preparedInvoice = yield* call(savePreparedInvoice, action.payload.preparedInvoiceId, action.payload.preparedInvoice);
    if (typeof preparedInvoice === "string") {
        yield* put(actions.savePreparedInvoiceFail(preparedInvoice));
        return;
    }
    yield* put(actions.savePreparedInvoiceSuccess(preparedInvoice));
}
function* watchSavePreparedInvoiceRequest() {
    yield* takeEvery(DynamicInvoiceDialogActionTypes.SavePreparedInvoiceRequest, savePreparedInvoiceHandler);
}
function* approvePreparedInvoiceHandler(action) {
    const apiResult = yield* call(getAppServerClient().finance.preparedInvoiceV2.approvePreparedInvoiceAsync, action.payload.preparedInvoiceId);
    if (apiResult.ok) {
        yield* put(actions.approvePreparedInvoiceSuccess(action.payload.preparedInvoiceId));
        yield* put(dynamicInvoicePageActions.hideDynamicInvoiceDialog());
        return;
    }
    yield* put(actions.approvePreparedInvoiceFail(apiResult.error));
}
function* watchApprovePreparedInvoiceRequest() {
    yield* takeEvery(DynamicInvoiceDialogActionTypes.ApprovePreparedInvoiceRequest, approvePreparedInvoiceHandler);
}
export const dynamicInvoiceDialogSagaInit = () => [
    fork(watchSaveAndApprovePreparedInvoiceRequest),
    fork(watchSavePreparedInvoiceRequest),
    fork(watchApprovePreparedInvoiceRequest)
];
